import React, { Component } from "react";
import './styles/tTipStyles.css'
import info from "../../assets/icons/info.svg";

class ToolTipA extends Component {
  toolDisplay = null;
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div >
        <center><div class="tip"><img src={info} alt='info'/><span>{this.props.content}</span></div></center>
      </div>
    );
  }
}

export default ToolTipA;
